
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.634 14.497a.775.775 0 00-.977-.498l-1.008.328a9.448 9.448 0 00.94-4.116c0-5.216-4.242-9.459-9.458-9.459S.67 4.995.67 10.211c0 5.216 4.244 9.459 9.46 9.459a.775.775 0 000-1.55c-4.36 0-7.908-3.548-7.908-7.91 0-4.36 3.547-7.907 7.908-7.907 4.36 0 7.908 3.547 7.908 7.908a7.894 7.894 0 01-.79 3.447l-.343-1.06a.775.775 0 00-1.475.478l.914 2.814a.775.775 0 00.977.498l2.814-.914a.775.775 0 00.498-.977z","fill":"#2F2F34"}})])
          )
        }
      }
    